import { Theme } from '@emotion/react'
/**
 * Implement the theme interface
 */
export const defaultTheme: Theme = {
    containerWidth: '1080px',
    primaryColor: {
        beige: {
            1: '#E5D3B3',
        },
        black: {
            1: '#02050A',
        },
        blue: {
            1: '#1D334E',
            2: '#4E7BBC',
            3: '#324C77',
        },
        grey: {
            1: '#919488',
            2: '#7F8274',
            3: '#63665B',
        },
        orange: {
            1: '  #FFBC5D',
        },
        white: {
            1: '#FEFEFB',
            2: '#FFFFFF',
            3: '#EAF8FB',
            4: '#F2F2F2',
        },
    },
    breakPoints: {
        tablet: '1420px',
        miniTablet: '1240px',
        largePhone: '940px',
        phone: '700px',
    },
}
